import React from "react";
import { QueryObserverResult, RefetchOptions } from "@tanstack/react-query";
import { UseFormReturn } from "react-hook-form";

import { TextInput } from "@dzambalaorg/mui-inputs-core";
import { FormWrapper } from "@dzambalaorg/mui-form";
import { useMutationQuery } from "@dzambalaorg/react-hooks";
import { Collapse, FormGrid } from "@dzambalaorg/ui-kit";

interface ICreateFeatureFlagDto {
  key: string;
  value: string;
}

interface ICreateFeatureFlagProps {
  open: boolean;
  refetch: (options?: RefetchOptions) => Promise<QueryObserverResult<Record<string, any>, Error>>;
}

const initialValues = { settingsKey: "", settingsValue: "" };

export const CreateFeatureFlag = ({ open, refetch }: ICreateFeatureFlagProps) => {
  const { mutateAsync, isPending } = useMutationQuery<ICreateFeatureFlagDto>("/settings", "POST");

  const onSubmit = async (values: Record<string, any>, form: UseFormReturn<any>) => {
    await mutateAsync({ data: { key: values.settingsKey, value: values.settingsValue } });
    await refetch();
    form.reset(initialValues);
  };

  return (
    <Collapse in={open}>
      <FormWrapper
        sx={{ display: "flex", flexDirection: "column", gap: 1, marginBottom: 2 }}
        formSubmitButtonProps={{ disabled: isPending }}
        initialValues={initialValues}
        onSubmit={onSubmit}
        testId={"SettingCreate"}
      >
        <FormGrid columns={[2]}>
          <TextInput name={"settingsKey"} />
          <TextInput name={"settingsValue"} />
        </FormGrid>
      </FormWrapper>
    </Collapse>
  );
};
